import React from 'react';

interface IEllipseContainer {
    children?: React.ReactNode;
}

const EllipseContainer: React.FC<IEllipseContainer> = ({ children }) => {
    return (
        <div
            style={{
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                maxWidth: 250,
            }}
        >
            {children}
        </div>
    );
};

export default EllipseContainer;
